import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { ISetMarketingSettingsRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useMarketingNotifications() {
  const client = useApiClientUser()

  const {
    mutate: setMarketingNotifications,
    isPending: isSettingMarketingNotifications,
    error,
  } = useMutation({
    mutationFn: async (props: ISetMarketingSettingsRequest) => {
      return await client.user
        .settingsControllerSetMarketingSettings(props, { secure: true })
        .then((res) => res.data)
    },
  })

  return {
    setMarketingNotifications,
    isSettingMarketingNotifications,
    error: getApiErrorMessage(
      error,
      'Marketingové nastavenia sa nepodarilo uložiť.'
    ),
  }
}

export { useMarketingNotifications }
